import { gxDashboardApprovalsPendingCountApi } from "@/app/apiConfig/services/paymentsAbstractApiLayer";
import { useT } from "@/app/hooks/useT";
import type { CountResponse } from "@/app/types/payments";
import {
  memo,
  useEffect,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";
import { CardItem } from "./CardItem";

interface ActionCardProp {
  onSelect: (value: string) => void;
  callCount: boolean;
  setCallCount: Dispatch<SetStateAction<boolean>>;
}

const ActionCard = memo(
  ({ onSelect, callCount, setCallCount }: ActionCardProp) => {
    const t = useT();

    const cardsData = [
      { id: "11", name: t("bulk_payments") },
      { id: "12", name: t("payrolls") },
      { id: "2", name: t("transaction") },
      { id: "1", name: t("beneficiary") },
      { id: "3", name: t("bill_payments") },
      { id: "4", name: t("loan_payment") },
      { id: "5", name: t("eipp_") },
      { id: "6", name: t("receivable_finance") },
      { id: "7", name: t("pdc") },
      { id: "8", name: t("card_payment") },
      { id: "9", name: t("user_approvals") },
      // { id: "10", name: t("payer_approvals") },
      { id: "13", name: t("rtp") },
    ];

    const [isSeeMoreOpened, setIsSeeMoreOpened] = useState<boolean>(false);

    const [countDetails, setCountDetails] = useState<CountResponse>();

    const handleSeeMore = () => {
      setIsSeeMoreOpened((prev: boolean) => !prev);
    };

    const getActionCardApi = async () => {
      try {
        const result = await gxDashboardApprovalsPendingCountApi();
        if (result?.data !== null) {
          setCountDetails(result?.data);
        }
      } catch (error) {
        console.error("ActionCard API failed:", error);
        setCountDetails(undefined);
      } finally {
        setCallCount(false);
      }
    };

    useEffect(() => {
      getActionCardApi();
    }, []);

    useEffect(() => {
      if (callCount) {
        getActionCardApi();
      }
    }, [callCount]);

    const setCount = (item: string) => {
      switch (item) {
        case "0":
          return countDetails?.total;
        case "2":
          return countDetails?.countOfTotalTransPay;
        case "1":
          return countDetails?.countOfBeneficiary;
        // case "10":
        //   return countDetails?.countOfTotalPayer;
        case "11":
          return countDetails?.countOfBulkpayment;
        case "12":
          return countDetails?.countOfBulkpayroll;
        case "13":
          return countDetails?.countOfRtp;
        default:
          return 0;
      }
    };

    if (countDetails?.total === 0) {
      return null;
    }
    
    return (
      <>
        <div className="gx-action-card-grid">
          <CardItem
            item={{ id: "0", name: t("all") }}
            first={true}
            setCount={setCount}
            onSelect={onSelect}
          />
          {(isSeeMoreOpened ? cardsData : cardsData.slice(0, 3)).map((item) => {
            return (
              <CardItem
                key={item.id}
                item={item}
                first={false}
                setCount={setCount}
                onSelect={onSelect}
              />
            );
          })}
        </div>
        <div className="gx-see-more-container">
          <div className="gx-line-container">
            <hr />
          </div>
          <button className="gx-see-more" onClick={handleSeeMore}>
            <span className="gx-p12-m">
              {isSeeMoreOpened ? t("see_less") : t("see_more")}
            </span>
          </button>
        </div>
      </>
    );
  },
);

export default ActionCard;
